import { SchedulingService } from './../../../services/scheduling.service'
import { ExcelTemplateTree, ExcelTemplateOperator, ExcelTemplate } from 'src/app/models/ExcelTemplate'
import { TreeService } from './../../../services/tree.service'
import { ExcelService } from './../../../services/excel.service'
import {
	Component,
	OnInit,
	OnDestroy,
	ViewChild,
	AfterViewInit
} from '@angular/core'
import { NgForm } from '@angular/forms'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs'
import { Router, ActivatedRoute } from '@angular/router'
import { NotificationService } from '../../../services/notification.service'
import { AWSService } from '../../../services/aws.service'
import { Company } from '../../../models/Company'
import { CompanyService } from '../../../services/company.service'
import { Address, CompanyAddress } from '../../../models/Address'
import * as moment_ from 'moment'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { deepcopy } from '../../../_helpers/Utils'
import { InsertDateComponent } from './../../modal/insert-date/insert-date.component'
import { MatDialog } from '@angular/material'
import { Demand } from 'src/app/models/Demand'
import { OperationServiceService } from 'src/app/services/operation.service.service'
import { setEnableCommunication, setEnableCloneInventory, setEnableLegalFundamentation } from 'src/app/_helpers/LocalStorage'
import { reTranslateModuleNames } from 'src/app/_helpers/Translate'

@Component({
	selector: 'app-company',
	templateUrl: './company.component.html',
	styleUrls: ['./company.component.scss']
})
export class CompanyComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChild('form') public form: NgForm
	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective
	public refreshTable: Subject<any> = new Subject()
	public datatableOptions: DataTables.Settings = {}
	public companies: Array<Company>
	public company: Company
	public urlUpload: string = 'teste'
	public open: boolean = false
	public openDelete: boolean = false
	public generateQrCode: boolean = false
	public qrCodeSource: string
	public signature_date: string
	public validity: string
	public nameFile: string
	public qtd_adminsUsed: number
	public qtd_evaluatorsUsed: number
	public qtd_operatorsUsed: number
	public qtd_inventorsUsed: number
	public subscriptionLoadingOn
	public subscriptionLoadingFalse
	public subscriptionGet
	public subscriptionAdd
	public subscriptionRemove
	public ViewValidation: ViewValidation = new ViewValidation()
	public statusContrato: string
	public alreadyHasSubdomain: boolean
	public systemModules: Array<{ id: number, companyModuleId: number, name: string, active: boolean }>

	constructor(
		private router: Router,
		private companyService: CompanyService,
		public notificationService: NotificationService,
		private activateRoute: ActivatedRoute,
		private awsService: AWSService,
		private excelService: ExcelService,
		private treeService: TreeService,
		public dialog: MatDialog,
		private operationServiceService: OperationServiceService,
		private schedulingService: SchedulingService


	) {}

	public ngOnInit(): void {
		localStorage.removeItem('comingFromCompany')
		this.fetchCompaniesResolver()
		this.company = new Company()
		this.company.mandatoryGoogleMaps = true
		this.company.mandatoryArcGisApps = false
		this.company.address = new CompanyAddress()
		this.companyService.getSystemModules().subscribe(modules => {
			this.systemModules = modules
		})

		document.querySelector('main').className = ''
		this.setupDatatables()
	}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	private setupDatatables(): void {
		this.datatableOptions = {
			language: {
				url:
					'//cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json'
			},
			pagingType: 'full_numbers',
			paging: true,
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: 10,
			lengthChange: false,
			columnDefs: [
				{
					targets: 'no-sort',
					orderable: false,
					width: '.1%'
				}
			]
		}
	}

	public fetchCompaniesResolver(): void {
		this.companies = this.activateRoute.snapshot.data.companies
	}

	public async getCompanies(): Promise<void> {
		try {
			const response: Array<
				Company
			> = await this.companyService.getCompanies(0, 100).toPromise()

			this.companies = response
			this.rerender()
		} catch (err) {
			this.notificationService.notify('Erro desconhecido', err && err.error && err.error.statusCode || 400)
		}
	}

	public onFileSelected(fileInput: any, mediaType: string): void {
		const file: any = fileInput.target.files[0]
		if (file) {
			this.notificationService.initLoading()
			this.awsService
				.uploadToS3(fileInput.target.files[0])
				.then(data => {
					if (mediaType == 'mediaCompany') {
						this.company.mediaCompany = data.Location
					} else if (mediaType == 'mediaPublicBody') {
						this.company.mediaPublicBody = data.Location
					} else if (mediaType == 'contract') {
						this.company.contract_media = data.Location
						this.nameFile = data.key
					}
					this.notificationService.stopLoading()
				})
				.catch(err => {
					this.notificationService.notify('Erro ao enviar arquivo', 400)
					console.log(err)
				})
		}
	}

	public clearMedia(mediaType: string): void {
		if (mediaType == 'mediaCompany') {
			this.company.mediaCompany = undefined
		} else if (mediaType == 'mediaPublicBody') {
			this.company.mediaPublicBody = undefined
		} else if (mediaType == 'contract') {
			this.company.contract_media = undefined
		}
	}

	public showMedia(mediaType): void {
		if (mediaType == 'mediaCompany') {
			window.open(this.company.mediaCompany)
		} else if (mediaType == 'mediaPublicBody') {
			window.open(this.company.mediaPublicBody)
		} else if (mediaType == 'contract') {
			window.open(this.company.contract_media)
		}
	}

	public async createOrEditCompanies(isEditing?: boolean): Promise<void> {
		try {
			if (this.signature_date) {
				const newdate: string = this.signature_date
					.split('/')
					.reverse()
					.join('-')
				const dateAssinatura: moment_.Moment = moment_(newdate)
				if (dateAssinatura) {
					this.company.signature_date = dateAssinatura.toDate()
				}
			}
			if (this.validity) {
				const newdate2: string = this.validity
					.split('/')
					.reverse()
					.join('-')
				const dateValidade: moment_.Moment = moment_(newdate2)
				if (dateValidade) this.company.validity = dateValidade.toDate()
			}

			// This resolves the issue with having a mandatory identification without
			// even having a identification procedure
			if (!this.company.manualTreeIdentification) {
				this.company.mandatoryIdentification = false
			}

			if (!this.company.manualTreeIdentificationInventory) {
				this.company.mandatoryIdentificationInventory = false
			}

			if (!this.company.enableAutomaticDemandConfirmationEmail) {
				this.company.enableAutomaticDemandConfirmationEmail = false
			}

			const parseCompanyModules = this.company.modules.map(module => {
				return {
					id: module.id,
					companyModuleId: module.companyModuleId,
					name: reTranslateModuleNames(module.name),
					active: module.active
				}
			})


			if (isEditing) {
				const res: any = await this.companyService
					.editCompany(this.company._id, {...this.company, modules: parseCompanyModules}).toPromise()

				this.notificationService.notify(res.message, 200)
			} else {
				const response: any = await this.companyService
				.addCompany({...this.company, modules: parseCompanyModules})
				.toPromise()

				this.notificationService.notify(response.message, 200)
			}

			this.refreshNewCompany()
		} catch (error) {
			console.log('Error', error)
			this.notificationService.notify(error.error.message || 'Erro desconhecido', error.error.statusCode || 400)
		}
	}

	public onInputChange(event: any): void {
		const input = event.target
		const value = input.value

		if (value.includes(',')) {
			input.value = value.replace(',', '.')
		}
	}

	public removeCompany(): void {
		this.subscriptionRemove = this.companyService
			.removeCompany(this.company._id)
			.subscribe(
				data => {
					this.refreshNewCompany()
					this.notificationService.notify(data.message, 200)
				},
				error => {
					console.error(error)
				}
			)

		return
	}

	// FIXME: Refactor
	public openModal(companySelected?: any): void {
		this.open = true
		document.querySelector('main').className = 'modal-active'
		const modal: any = document.getElementsByClassName('modal active')
		setTimeout(() => {
			modal[0].scrollTop = 0
		}, 250)
		if (companySelected) {
			this.company = deepcopy(companySelected)

			this.alreadyHasSubdomain = this.company.subdomain != null ? true : false

			const modulesNotInCompany = this.systemModules.filter(module => {
				return !this.company.modules.find(companyModule => companyModule.id === module.id)
			})

			this.company.modules = this.company.modules.concat(modulesNotInCompany.map(module => {
				return {
					id: module.id,
					companyModuleId: module.companyModuleId,
					name: module.name,
					active: false
				}
			}))

			// order by this.company.modules like this.systemModules

			this.company.modules = this.systemModules.map(module => {
				return this.company.modules.find(companyModule => companyModule.id === module.id)
			})

			const contract_media: string = this.company.contract_media
			if (contract_media) {
				this.nameFile = contract_media.split('.com/')[1]
			}
			if (this.company.validity) {
				this.validity = moment_(this.company.validity).format(
					'DD/MM/YYYY'
				)
			}
			if (this.company.signature_date) {
				this.signature_date = moment_(
					this.company.signature_date
				).format('DD/MM/YYYY')
			}
			if (this.company.qtd_adminsUsed) {
				this.qtd_adminsUsed = this.company.qtd_adminsUsed
			} else {
				this.qtd_adminsUsed = 0
			}
			if (this.company.qtd_evaluatorsUsed) {
				this.qtd_evaluatorsUsed = this.company.qtd_evaluatorsUsed
			} else {
				this.qtd_evaluatorsUsed = 0
			}
			if (this.company.qtd_operatorsUsed) {
				this.qtd_operatorsUsed = this.company.qtd_operatorsUsed
			} else {
				this.qtd_operatorsUsed = 0
			}
			if (this.company.qtd_inventorsUsed) {
				this.qtd_inventorsUsed = this.company.qtd_inventorsUsed
			} else {
				this.qtd_inventorsUsed = 0
			}

		} else {
			this.company = new Company()
			this.company.mandatoryGoogleMaps = true
			this.company.address = new CompanyAddress()
			this.qtd_operatorsUsed = 0
			this.qtd_evaluatorsUsed = 0
			this.qtd_inventorsUsed = 0
			this.qtd_adminsUsed = 0
			this.company.modules = this.systemModules.map(module => {
				return {
					id: module.id,
					companyModuleId: module.companyModuleId,
					name: module.name,
					active: false
				}
			})
		}

		const dateAtual: string = moment_().format('DD/MM/YYYY')
		const dateContrato: string = moment_(this.company.validity).format(
			'DD/MM/YYYY'
		)

		const dateAtualMoment: Date = moment_(dateAtual).toDate()
		const dateContratoMoment: Date = moment_(dateContrato).toDate()

		if (dateAtualMoment > dateContratoMoment) {
			this.statusContrato = 'Inativo'
		} else {
			this.statusContrato = 'Ativo'
		}
	}

	public closeModal(): void {
		this.open = false
		document.querySelector('main').className = ''
	}

	public openModalDelete(CompanySelected: any): void {
		this.openDelete = true
		if (CompanySelected) {
			this.company = deepcopy(CompanySelected)
		}
	}

	public closeModalDelete(): void {
		this.openDelete = false
	}

	public async openModalQrCode(company): Promise<void> {
		if ((!company.appSolicitante || !company.publicPanel) && !company.subdomain) {
			console.log('Empresa não possui app solicitante ou painel público')
			return
		}

		this.generateQrCode = true

		if (company) {
			this.company = deepcopy(company)

			const companyQrCode = await this.companyService.getCompanyQrCodeForRequester(company._id).toPromise()

			this.qrCodeSource = companyQrCode
		}
	}

	public closeModalGenerateQrCode(): void {
		this.generateQrCode = false
		this.qrCodeSource = ''
	}

	public downloadQrCode(company): void {
		const link = document.createElement('a')
		link.href = this.qrCodeSource
		link.download = `${company.subdomain}-qr-code.png`

		link.click()
	}

	public refreshNewCompany(): void {
		if (this.form) {
			this.form.reset()
		}
		this.closeModal()
		this.closeModalDelete()
		this.getCompanies()
		this.company = new Company()
		this.company.mandatoryGoogleMaps = true
		this.company.address = new CompanyAddress()
	}

	public entrarCliente(company: Company): void {
		localStorage.setItem('loggedCompany', 'true')
		localStorage.setItem('identifier', company.identifierName)
		localStorage.setItem('companyId', company._id)
		localStorage.setItem('companyName', company.social_name)
		setEnableLegalFundamentation(company.enableLegalFundamentation)
		setEnableCommunication(company.enableNotifications)
		setEnableCloneInventory(company.enabledCloneInventory)
		this.router.navigate(['/redirect'])
	}

	public rerender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public ngOnDestroy(): void {
		if (this.refreshTable) this.refreshTable.unsubscribe()
		if (this.subscriptionLoadingOn) this.subscriptionLoadingOn.unsubscribe()
		if (this.subscriptionLoadingFalse) {
			this.subscriptionLoadingFalse.unsubscribe()
		}
		if (this.subscriptionGet) this.subscriptionGet.unsubscribe()
		if (this.subscriptionAdd) this.subscriptionAdd.unsubscribe()
		if (this.subscriptionRemove) this.subscriptionRemove.unsubscribe()
	}

	public async exportAsXLSX(companyId: string) {
		const dialogRef = this.dialog.open(InsertDateComponent)
		dialogRef.componentInstance.close = dialogRef.close
		let dateStart: number
		let dateEnd: number
		dialogRef.afterClosed().subscribe(async result => {
			if (!dialogRef.componentInstance.cancel) {
				let dateAux = dialogRef.componentInstance.dateStart.split('/')
				dateStart = new Date(Number(dateAux[2]), Number(dateAux[1]) - 1, Number(dateAux[0])).getTime()
				dateAux = dialogRef.componentInstance.dateEnd.split('/')
				dateEnd = new Date(Number(dateAux[2]), Number(dateAux[1]) - 1, Number(dateAux[0])).getTime()
				this.notificationService.notify('Aguarde, estamos montando seu excel. O download iniciará em breve.', 200)
			}


			if (!dateStart || !dateEnd) return

			const jsonScheduling: any = new Array()
			const demands: Array<Demand> = await this.schedulingService
			.getDemandsByCompanyId(companyId, dateStart, dateEnd)
			.toPromise()

			demands.forEach(demand => {
				const template: ExcelTemplate = new ExcelTemplate()
				template.Tipo = 'Agendamento Avaliação'
				template.Protocolo = demand.identification
				template.Requerente = demand.requester
				template.Email_Requerente = demand.email_requester
				template.Telefone_Requerente = demand.tel_requester
				template.CPF_Requerente = demand.cpf_requester
				template.Endereço = demand.address.street
				template.Observações = demand.observation
				if (demand.appraisal) {
					template.Protocolo_Avaliação = demand.appraisal.identification
					template.Agendamento = moment_(
						demand.appraisal.scheduling_date
					).format('DD/MM/YYYY')
					template.Avaliador = demand.appraisal.evaluator.name
					template.Status = demand.appraisal.status
					if (template.Status === 'REALIZADO') {
						template.Status = 'REALIZADA'
					}
					if (template.Status === 'ATRASADO') {
						template.Status = 'ATRASADA'
					}
					if (template.Status === 'CANCELADO') {
						template.Status = 'CANCELADA'
					}
				} else {
					template.Agendamento = ''
					template.Avaliador = ''
					template.Status = 'AGENDAR'
				}
				jsonScheduling.push(template)
			})


			const jsonManejo: any = new Array()
			try {
				const operationService = await this.operationServiceService
				.getListOperationsForScheduling(companyId, dateStart, dateEnd)
				.toPromise()

				operationService.forEach(operationService => {
					const template: ExcelTemplateOperator = new ExcelTemplateOperator()
					template.Tipo = 'Agendamento Operação'
					if (operationService.appraisal) {
						template.Numero_Árvore = operationService.appraisal.tree.identification
						template.Protocolo_Avaliação =
						operationService.appraisal.identification
						template.Risco_Avaliação =
						operationService.appraisal.evaluationResult.degreeRisk.title
						template.Data_Avaliação = moment_(
							operationService.appraisal.evaluationResult.conclusionDate
							).format('DD/MM/YYYY')
						template.Endereço = operationService.appraisal.address &&  operationService.appraisal.address.street || operationService.appraisal.tree && String(operationService.appraisal.tree.address)

					}
					template.Protocolo_Manejo = operationService.identification

					if (operationService.operator) {
						template.Agendamento = moment_(
							operationService.schedulingDate
						).format('DD/MM/YYYY')
						template.Operador = operationService.operator.name

						if (operationService.status === 'REALIZADO') {
							template.Status = 'REALIZADA'
						}
						if (operationService.status === 'ATRASADO') {
							template.Status = 'ATRASADA'
						}
						if (operationService.status === 'CANCELADO') {
							template.Status = 'CANCELADA'
						}
					} else {
						template.Agendamento = ''
						template.Operador = ''
						template.Status = 'AGENDAR'
					}

					jsonManejo.push(template)
				})
			} catch (err) {

			}


			const jsonAppraisal: any = new Array()
			const reportsAppraisal: Array<any> = await this.treeService.getAppraisalReports(companyId, dateStart, dateEnd).toPromise()

			reportsAppraisal && reportsAppraisal.forEach(data => {

				const template: ExcelTemplateTree = new ExcelTemplateTree()
				template.Tipo = 'Avaliação'
				template.Árvore_id = data.evaluation.treeNumber
				template.Responsável = data.evaluation.responsible
				template.Conselho_de_classe_responsável = data.evaluation.crea
				template.Data = data.evaluation.date
				template.Duração_Avaliação = data.evaluation.evaluationTime.replace('NaN', '0')
				template.Endereço = data.locationAndSituation.address
				template.Coordenadas_Geográficas = data.locationAndSituation.geographicCoordinates.length && data.locationAndSituation.geographicCoordinates[0] + ',' + data.locationAndSituation.geographicCoordinates[1]
				template.Árvore_Morta = data.locationAndSituation.deadTree ? 'Sim' : 'Não'
				template.Categoria_Local = data.locationAndSituation.locationCategory
				template.Observações = data.locationAndSituation.comments
				template.Foto_Principal = data.LocationAndSituation && data.LocationAndSituation.images[0].url
				template.Espécie = data.tree.species
				template.Nome_Popular = data.tree.popularName
				template.Família = data.tree.family
				template.Categoria_Especial = data.tree.specialCategory
				template.Origem = data.tree.source
				template.Altura_total = data.tree.totalHeight && data.tree.totalHeight + 'm'
				template.Altura_caule = data.tree.stemHeight && data.tree.stemHeight + 'm'
				template.Projeçao_copa = data.tree.cupProjection && data.tree.cupProjection + 'm'
				template.DAP = data.tree.dapCap && data.tree.dapCap + 'cm'
				template.Volume_estimado_madeira = data.tree.woodVolume + 'm³'
				template.Valor_especial = String(data.tree.specialValue)
				template.Grau_Risco =  data.evaluationResult && (data.evaluationResult.degreeOfRisk.title + ' - ' + data.evaluationResult.nextEvaluation.title)
				template.Risco_Residual =  data.evaluationResult && data.evaluationResult.degreeOfRisk.title + ' - ' + data.evaluationResult.nextEvaluation.title
				template.Próxima_Avaliação = data.evaluationResult && data.evaluationResult.nextEvaluation.month + 'meses'
				template.Solicitar_Avaliação_Aprofundada = data.evaluationResult && data.evaluationResult.depthEvaluation.requested ? 'Sim'	: 'Não'
				template.Probabilidade_queda = data.evaluationResult && data.evaluationResult.fallProbability.title
				template.Probabilidade_impacto = data.evaluationResult && data.evaluationResult.impactProbability.title
				template.Consequência_queda = data.evaluationResult && data.evaluationResult.fallConsequence.title

				template.Recomendações_manejo = ''
				data.recommendationsManagement.map(management => {
					template.Recomendações_manejo += `${management.name}; `
				})
				template.Considerações = data.considerations
				template.Avaliação_Risco = (data.riskAssessment.av1.status === 'released' ? data.riskAssessment.av1.title + '; ' : '' ) + (data.riskAssessment.av2.status === 'required' ? data.riskAssessment.av2.title + '; ' : '') + (data.riskAssessment.av3.status === 'requested' ? data.riskAssessment.av3.title : '')
				template.Respostas_avaliação = ''
				template.Fotos_Árvore = ''
				data.answersNoImagens.map(result => {
					template.Respostas_avaliação += `${result.question} - ${result.answer}; `
				})

				data.answersWithImagens && data.answersWithImagens.map(result => {
					template.Fotos_Árvore += `${result.question}: ${result.url}; `
				})

				jsonAppraisal.push(template)
			})

			const jsonOperations: any = new Array()
			try {
				const reportsOperations: Array<any> = await this.treeService.getOperationReports(companyId, dateStart, dateEnd).toPromise()

				reportsOperations && reportsOperations.forEach(data => {

					const template: ExcelTemplateTree = new ExcelTemplateTree()
					template.Tipo = 'Operação'
					template.Árvore_id = data.operation.treeNumber
					template.Responsável = data.operation.responsible
					template.Data = data.operation.date
					template.Duração_Avaliação = data.operation.time
					template.Endereço = data.locationAndSituation.address
					template.Coordenadas_Geográficas = data.locationAndSituation.geographicCoordinates.length && data.locationAndSituation.geographicCoordinates[0] + ',' + data.locationAndSituation.geographicCoordinates[1]
					template.Árvore_Morta = data.locationAndSituation.deadTree ? 'Sim' : 'Não'
					template.Categoria_Local = data.locationAndSituation.locationCategory
					template.Observações = data.locationAndSituation.comments
					template.Foto_Principal = data.locationAndSituation && data.locationAndSituation.images[0].url
					template.Espécie = data.tree.species
					template.Nome_Popular = data.tree.popularName
					template.Família = data.tree.family
					template.Categoria_Especial = data.tree.specialCategory
					template.Origem = data.tree.source
					template.Altura_total = data.tree.totalHeight && data.tree.totalHeight + 'm'
					template.Altura_caule = data.tree.stemHeight && data.tree.stemHeight + 'm'
					template.Projeçao_copa = data.tree.cupProjection && data.tree.cupProjection + 'm'
					template.DAP = data.tree.dapCap && data.tree.dapCap + 'cm'
					template.Volume_estimado_madeira = data.tree.woodVolume + 'm³'
					template.Valor_especial = String(data.tree.specialValue)
					template.Recomendações_manejo = ''
					template.Fotos_Árvore = ''

					data.recommendationsManagement.map(management => {
						template.Recomendações_manejo += `${management.name ? management.name : ''} ${management.status === 'removed' ? ' EXCLUÍDO' : management.status === 'included' ? ' INCLUÍDO' : 'APROVADO'}; `
					})
					template.Considerações = data.considerations
					data.imagesManagement.map(image => {
						template.Fotos_Árvore += image.url + '; '
					})

					jsonOperations.push(template)
				})

			} catch (er) {

			}


			const json = jsonScheduling.concat(jsonManejo).concat(jsonAppraisal).concat(jsonOperations)

			if (json.length) {
			this.excelService.exportAsExcelFile(json, 'Relatório_Completo')
			} else this.notificationService.notify('Não há dados a serem exportados', 420)
		})


	}

	public exportBackup(companyId: string) {
		this.companyService.exportBackup(companyId).subscribe(() => {
			this.notificationService.notify('Backup em andamento, avisaremos no seu email quando finalizarmos', 200)
		}, err => {
			console.log('error backup', err)
		})
	}
}
